import { Provider } from '@vgtv/api-client';

import { getHomepageSlug } from '../../shared/helpers/getHomepageSlug';
import type { PageData } from '../tracking/pageData';

export const getContentParams = (pageData: PageData) => {
  if (pageData.pageType === 'asset') {
    return {
      content_id: String(pageData.entity.id),
      type: 'video',
    };
  }

  if (pageData.pageType === 'category') {
    return {
      content_id: `category-${pageData.entity.id}`,
      type: 'other',
    };
  }

  if (pageData.pageType === 'tag') {
    return {
      content_id: `tag-${pageData.entity.id}`,
      type: 'other',
    };
  }

  if (pageData.pageType === 'story') {
    return {
      content_id: `story-${pageData.entity.id}`,
      type: 'other',
    };
  }

  if (pageData.pageType === 'custom') {
    if (pageData.entity.slug === getHomepageSlug(Provider.VGTV)) {
      return {
        content_id: 'vgtvfront',
        type: 'other',
      };
    }

    return {
      content_id: `custom-${pageData.entity.slug}`,
      type: 'other',
    };
  }

  return {};
};
